import {
  INICIA_ESCOLA,
  NOVO_ESCOLA,
  BUSCA_ESCOLA_EDICAO,
  CANCELA_EDICAO,
  INICIO_ESCOLA_SUCESSO,
  SALVA_ESCOLA_SUCESSO,
  REMOVE_ESCOLA_SUCESSO,
  BUSCA_ESCOLA_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  ALTERACAO_CAMPO_MASCARA_CEP,
  ALTERACAO_CAMPO_MASCARA_CNPJ,
  ALTERACAO_CAMPO_MASCARA_CPF,
  ALTERACAO_CAMPO_MASCARA_DATE,
  ALTERACAO_CAMPO_MASCARA_TELEFONE,
  APLICA_FILTRO_ESCOLA,
  LISTA_ESCOLA,
  LISTA_ESCOLA_SUCESSO,
  LIMPAR_ESCOLA,
  ADICIONA_ESCOLA_CURSO,
  REMOVE_ESCOLA_CURSO,
  ALTERA_ESCOLA_CURSO,
  LISTA_CURSOS_ESCOLA_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_SUCESSO
} from "constants/ActionTypes";

const INIT_STATE = {
  // Configuração da Grid
  colunasGrid: [
    { titulo: 'Código INEP', propriedadeApi: 'codigoInep', alinhamento: 'left' },
    { titulo: 'Nome', propriedadeApi: 'nome', alinhamento: 'left' },
    { titulo: 'Sigla', propriedadeApi: 'sigla', alinhamento: 'left' },
    { titulo: 'Dependência', propriedadeApi: 'dependenciaAdministrativa', alinhamento: 'left' },
    { titulo: 'Situação', propriedadeApi: 'situacaoFuncionamento', alinhamento: 'left' }
  ],

  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  escolaCarregada: null,
  // Lista para combo de Local Controlado e campo selecionado
  listaLocaisControlados: [],
  idLocalControlado: 0,
  listaCursos: [],
  listaAnosLetivosPorEscola: [],
  escolaCursos: [],

  // Campos do Formulario (mínimos para listagem/edição)
  id: 0,
  codigoInep: '',
  nome: '',
  sigla: '',
  dependenciaAdministrativa: '',
  situacaoFuncionamento: '',

  // Filtros
  nomeEscolaFiltro: ''
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_ESCOLA: {
      return {
        ...state,
        // Não alteramos o flag de edição aqui para evitar que a tela volte para a lista
        // quando o formulário de "Nova Escola" dispara INICIA_ESCOLA para carregar dados auxiliares
        loader: true,
        carregandoLista: true,
        // Mantém o texto do filtro atual (caso venha da lista) em vez de zerar sempre
        textoFiltro: state.textoFiltro,
      }
    }
    case NOVO_ESCOLA: {
      return {
        ...state,
        edicao: true,
        escolaCarregada: null,
        id: 0,
        codigoInep: '',
        nome: '',
        sigla: '',
        dependenciaAdministrativa: '',
        situacaoFuncionamento: ''
      }
    }
    case CANCELA_EDICAO: {
      return {
        ...state,
        edicao: false,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case BUSCA_ESCOLA_EDICAO: {
      return {
        ...state,
        loader: true,
      }
    }
    case INICIO_ESCOLA_SUCESSO: {
      const retorno = action.payload;
      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listGrid: retorno.escolas,
        listaLocaisControlados: Array.isArray(retorno.locaisControlados) ? retorno.locaisControlados.map(l => ({ id: l.id || l.Id, title: l.descricaoLocalControlado || l.DescricaoLocalControlado })) : state.listaLocaisControlados
      }
    }
    case SALVA_ESCOLA_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case REMOVE_ESCOLA_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case LISTA_ESCOLA: {
      return {
        ...state,
        loader: true,
      }
    }
    case APLICA_FILTRO_ESCOLA: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto
      }
    }
    case LISTA_ESCOLA_SUCESSO: {
      const retorno = action.payload;
      return {
        ...state,
        loader: false,
        listGrid: retorno.escola,
        listGridComFiltro: retorno.escola,
      }
    }
    case LIMPAR_ESCOLA: {
      return {
        ...state,
        nomeEscolaFiltro: '',
        textoFiltro: ''
      }
    }
    case BUSCA_ESCOLA_EDICAO_SUCESSO: {
      // A saga agora envia { escola, localControlado }
      const payload = action.payload || {};
      const retorno = payload.escola || payload || {};
      const localControladoDetalhe = payload.localControlado || null;
      // Se recebemos o local detalhado, garantimos que ele esteja na lista para o select desabilitado
      let listaLocais = state.listaLocaisControlados || [];
      if (localControladoDetalhe && (localControladoDetalhe.id || localControladoDetalhe.Id)) {
        const idLocal = Number(localControladoDetalhe.id || localControladoDetalhe.Id);
        const titleLocal = localControladoDetalhe.descricaoLocalControlado || localControladoDetalhe.DescricaoLocalControlado || localControladoDetalhe.title || '';
        const jaExiste = listaLocais.some(l => Number(l.id || l.Id) === idLocal);
        if (!jaExiste) {
          listaLocais = [...listaLocais, { id: idLocal, title: titleLocal }];
        }
      }
      const cursosRaw = retorno.escolaCursos || retorno.cursosEscola || retorno.cursos || retorno.Cursos || [];
      const escolaCursos = Array.isArray(cursosRaw)
        ? cursosRaw.map(c => ({
            cursoId: Number(c.cursoId || c.CursoId || c.idCurso || c.IdCurso || c.id || c.Id || 0),
            autorizacao: c.autorizacao || c.Autorizacao || '',
            anosLetivos: typeof c.anosLetivos !== 'undefined' ? c.anosLetivos : (typeof c.AnosLetivos !== 'undefined' ? c.AnosLetivos : '')
          }))
        : [];
      return {
        ...state,
        edicao: true,
        loader: false,
        escolaCarregada: retorno,
        listaLocaisControlados: listaLocais,
        // Normaliza possíveis chaves em PascalCase vindas do backend
        id: retorno.id || retorno.Id || 0,
        codigoInep: retorno.codigoInep || retorno.CodigoInep || '',
        nome: retorno.nome || retorno.Nome || '',
        sigla: retorno.sigla || retorno.Sigla || '',
        dependenciaAdministrativa: retorno.dependenciaAdministrativa || retorno.DependenciaAdministrativa || '',
        situacaoFuncionamento: retorno.situacaoFuncionamento || retorno.SituacaoFuncionamento || '',
        idLocalControlado: retorno.idLocalControlado || retorno.IdLocalControlado || 0,
        escolaCursos,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
        edicao: false
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false
      }
    }
    case ALTERACAO_CAMPO: {
      return {
        ...state,
        [action.payload.target.name]: action?.payload?.target?.value,
      }
    }
    case ALTERACAO_COMBO: {
      return {
        ...state,
        [action.payload.nomeCombo]: action.payload.valor,
      }
    }
    case ALTERACAO_CHECK: {
      var retorno = action.payload;
      return {
        ...state,
        [retorno.name]: retorno.value
      }
    }
    case ALTERACAO_DATEPICKER: {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      }
    }
    case ALTERACAO_CAMPO_MASCARA_CEP: {
      return {
        ...state,
        cep: action.payload.value,
      }
    }
    case ALTERACAO_CAMPO_MASCARA_DATE: {
      return {
        ...state,
        date: action.payload.value,
      }
    }
    case ALTERACAO_CAMPO_MASCARA_TELEFONE: {
      return {
        ...state,
        telefone: action.payload.value,
      }
    }
    case ALTERACAO_CAMPO_MASCARA_CPF: {
      return {
        ...state,
        cpf: action.payload.value,
      }
    }
    case ALTERACAO_CAMPO_MASCARA_CNPJ: {
      return {
        ...state,
        cnpj: action.payload.value,
      }
    }
    case ADICIONA_ESCOLA_CURSO: {
      const item = action.payload || {};
      const cursoId = Number(item.cursoId || 0);
      const jaExiste = (state.escolaCursos || []).some(x => Number(x.cursoId || 0) === cursoId);
      return {
        ...state,
        escolaCursos: jaExiste ? state.escolaCursos : [...(state.escolaCursos || []), {
          cursoId,
          autorizacao: item.autorizacao || '',
          anosLetivos: typeof item.anosLetivos !== 'undefined' ? item.anosLetivos : ''
        }]
      }
    }
    case REMOVE_ESCOLA_CURSO: {
      const { cursoId } = action.payload || {};
      const idNum = Number(cursoId || 0);
      const lista = (state.escolaCursos || []).filter(x => Number(x.cursoId || 0) !== idNum);
      return {
        ...state,
        escolaCursos: lista
      }
    }
    case ALTERA_ESCOLA_CURSO: {
      const { cursoId, changes } = action.payload || {};
      const idNum = Number(cursoId || 0);
      const lista = (state.escolaCursos || []).map(x => {
        if (Number(x.cursoId || 0) !== idNum) return x;
        const atual = { ...x };
        if (typeof changes !== 'object' || !changes) return atual;
        const out = { ...atual };
        if (Object.prototype.hasOwnProperty.call(changes, 'autorizacao')) out.autorizacao = changes.autorizacao;
        if (Object.prototype.hasOwnProperty.call(changes, 'anosLetivos')) out.anosLetivos = changes.anosLetivos;
        return out;
      });
      return {
        ...state,
        escolaCursos: lista
      }
    }
    case LISTA_CURSOS_ESCOLA_SUCESSO: {
      const retorno = action.payload || {};
      const cursos = Array.isArray(retorno.cursos) ? retorno.cursos : [];
      return {
        ...state,
        listaCursos: cursos
      }
    }
    case LISTA_ANOS_LETIVOS_POR_ESCOLA_SUCESSO: {
      const retorno = action.payload || {};
      const anos = Array.isArray(retorno.anos) ? retorno.anos : [];
      return {
        ...state,
        listaAnosLetivosPorEscola: anos
      }
    }
    default:
      return state;
  }
};
